import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn("Supabase: REACT_APP_SUPABASE_URL o REACT_APP_SUPABASE_ANON_KEY no configurados en .env.local");
}

export const supabase = createClient(supabaseUrl || "", supabaseAnonKey || "");
